<template>
  <div>
    <b-table
      :fields="fields"
      :items="getCompanyHolidayList"
      :busy="getCompanyHolidayListBusy"
      responsive
      hover
      @row-clicked="updateHoliday"
      ref="holiday-settings-table"
      table-class="table-head-custom table-vertical-center"
      show-empty
    >
      <!-- begin: t-head -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>
      <!-- end: t-head -->

      <!-- begin: t-row -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>
      <!-- end: t-row -->

      <!--  begin:: actions    -->
      <template v-slot:cell(actions)="data">
        <div class="d-flex flex-row justify-content-left">
          <button
            class="btn btn-icon btn-light btn-hover-primary mr-3"
            v-b-tooltip.hover="$t('HOLIDAY.UPDATE')"
            v-on:click="updateHoliday(data.item)"
          >
            <span class="svg-icon svg-icon-gray menu-icon">
              <inline-svg src="/media/svg/icons/Communication/Write.svg" />
            </span>
          </button>

          <button
            class="btn btn-icon btn-light btn-hover-danger mr-3"
            v-on:click="deleteHoliday(data)"
            v-b-tooltip.hover="$t('HOLIDAY.DELETE')"
          >
            <span class="svg-icon svg-icon-gray menu-icon">
              <inline-svg src="/media/svg/icons/General/Trash.svg" />
            </span>
          </button>
          <!-- end::: delete-holiday button -->
        </div>
      </template>
      <!--  end:: actions    -->
      <template #table-busy>
        <AppLoader></AppLoader>
      </template>

      <template #empty>
        <AppEmptyList
          text-top="There's no holiday for the selected year"
          text-bottom="Please click create to add holiday"
        ></AppEmptyList>
      </template>
    </b-table>

    <b-pagination
      v-if="getCompanyHolidayList.length"
      pills
      size="lg"
      align="right"
      v-model="getCompanyHolidayListPagination.current_page"
      :total-rows="getCompanyHolidayListPagination.total"
      :per-page="getCompanyHolidayListPagination.per_page"
      @change="changePage"
    ></b-pagination>

    <HolidayManagementModal
      :name="selectedHolidayName"
      :holiday="selectedHoliday"
      @close="closeModal"
    ></HolidayManagementModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import swal from "sweetalert";
import HolidayManagementModal from "@/modules/setting/components/holiday/HolidayManagementModal";
import dayjs from "dayjs";
import AppEmptyList from "@/modules/core/components/empty/AppEmptyList";

export default {
  name: "HolidaySettingsTable",
  components: { AppEmptyList, HolidayManagementModal, AppLoader },
  props: ["reload"],
  data() {
    return {
      fields: [
        { key: "index", label: "#" },
        {
          key: "name",
          label: this.$t("HOLIDAY.HOLIDAY"),
          stickyColumn: true,
          sortable: true,
        },
        {
          key: "date",
          label: this.$t("HOLIDAY.DATE"),
          sortable: true,
          class: "font-weight-bolder",
          formatter: (date) => {
            return dayjs(date).format("DD/MM/YYYY");
          },
        },
        { key: "actions", label: this.$t("EMPLOYEETABLE.ACTIONS") },
      ],
      selectedHolidayName: "",
      selectedHoliday: {},
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    /**
     * Fetch the list.
     * @returns {Promise<any>}
     */
    fetch() {
      return this.$store.dispatch("fetchCompanyHolidays");
    },

    /**
     *
     */
    closeModal() {
      this.fetch();
      this.$bvModal.hide("manage-holiday-modal");
    },

    /**
     * Change page.
     *
     * @param page
     */
    changePage(page) {
      this.$store.commit("setCompanyHolidayListPaginationPage", page);
      this.$store.dispatch("fetchCompanyHolidays");
    },

    /**
     * Show holiday form.
     *
     * @param item the holiday
     */
    updateHoliday(item) {
      console.log(item);

      this.selectedHolidayName = item.name;
      this.selectedHoliday = item;

      console.log("Selected holiday: ", this.selectedHoliday);
      this.$store.dispatch("changeCompanyHolidayForm", {
        form: item,
      });

      this.$bvModal.show("manage-holiday-modal");
    },

    /**
     * Delete holiday.
     *
     * @param data
     */
    deleteHoliday(data) {
      console.log(data);
      const groupName = data.item.name;
      swal({
        title: this.$t("ALERT.SURE"),
        text: groupName + " will be deleted",
        icon: "warning",
        showCancelButton: true,
        dangerMode: true,
        button: {
          text: this.$t("BUTTON.OKAY"),
          closeModal: false,
        },
        closeOnConfirm: false,
        closeOnCancel: false,
      })
        .then((willDelete) => {
          if (willDelete) {
            return this.$store
              .dispatch("deleteCompanyHoliday", data.item.id)
              .then(() => this.$store.dispatch("fetchCompanyHolidays"));
          } else {
            throw null;
          }
        })
        .then((data) => data)
        .then(() => {
          swal(this.$t("ALERT.CONFIRM"), {
            icon: "success",
            text: groupName + " successfully deleted",
          });
        })
        .catch((err) => {
          if (err) {
            swal("Oh noes!", "The AJAX request failed!", "error");
          } else {
            swal.stopLoading();
            swal.close();
          }
        });
    },
  },
  computed: {
    ...mapGetters([
      "getCompanyHolidayList",
      "getCompanyHolidayListPagination",
      "getCompanyHolidayListBusy",
    ]),
  },
  watch: {
    reload() {
      console.log("Reload Table!");
      this.$store.dispatch("fetchCompanyHolidays");
    },
  },
};
</script>

<style scoped></style>
